const ACTIVITY_TYPES = Object.freeze({
    TASK: 'task',
    EVENT: 'event',
    PHONECALL: 'phonecall',
    EMAIL: 'email',
});
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');
export default {
    data() {
        return {
            ACTIVITY_TYPES,
        };
    },
    computed: {
        ...mapStateUser({
            userId: 'id',
            isAdmin: 'isAdmin',
        }),
    },
    methods: {
        refreshListing() {
            window.sellsyapp.$trigger('activities-listing-table:refresh');
            this.$emit('close');
        },
        openLegacyForm(activity) {
            if (activity?.type === ACTIVITY_TYPES.PHONECALL) {
                PhoneCall.addCall(
                    activity.related.id,
                    activity.related.type,
                    activity.activityId ?? activity.id,
                    this.refreshListing,
                );
                this.$emit('close');
            } else {
                Activities.openActivityForm(
                    activity.activityId ?? activity.id,
                    null,
                    null,
                    () => this.refreshListing,
                    'event',
                );
            }
        },
        isOwner(ownerId) {
            return ownerId === this.userId;
        },
    },
};
